module.exports = __webpack_public_path__ + "static/case_studies.2fb2e4db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/case_studies.jpg
// module id = 655
// module chunks = 170326373320454